import { useQuery } from '@tanstack/react-query';
import { fetchRatesAndBrackets } from '../api';
import { RatesAndBrackets, Scheme, Period } from '../api-client';

const placeholderData: RatesAndBrackets = {
  employer_pension_contribution_rate: '0%',
  employee_pension_contribution_rate: undefined,
  apprenticeship_levy_rate: '0%',
  national_insurance: {
    brackets: []
  }
};

export const useRatesAndBrackets = (scheme: Scheme | null, period: Period | null) => {
  return useQuery({
    queryKey: ['ratesAndBrackets', scheme?.value, period?.value],
    queryFn: () => fetchRatesAndBrackets(scheme!.value, period!.value),
    enabled: !!(scheme && period),
    placeholderData:
      (previousData: RatesAndBrackets | undefined) => previousData || placeholderData,
  });
};
